import React, {useEffect, useState} from "react"
import './Step2Bd.scss'
import {Form, Row, Col, Select, Button} from 'antd'
import {getAreasPromise} from '../../../../promises'
import { getGruposPromise } from '../../../../../Register/promises'
import formTypeValidator from "../../../../../../helpers/formTypeValidator"
import { useTranslation } from 'react-i18next'

const Step2Bd = ({formBd, next2Bd, prev, currentUser, form}) => {
    const { t } = useTranslation()
    const [area, setArea] = useState([])
    const { getFieldDecorator, validateFields, setFieldsValue } = form;
    const [grupos, setGrupos] = useState([]);
    const [category, setCategory] = useState('CLIENTE');

    useEffect(() => {
      getAreasPromise().then(response => {
          setArea(response);
      })
      getGruposPromise('ALL').then(response => {
          setGrupos(response);
      })
    }, [])

    const nextStepLocal = () => {
        validateFields(['category', 'typePerson', 'company', 'area', 'segment', 'typeDecl']).then((c) => {
            next2Bd(c)
        }).catch(err => {
            console.log(err)
        })
    }

      const onChangeCategory = (value) => {
        setCategory(value)
        setFieldsValue({typeDecl: null})
      }

    return (
        <div className="step2bd-content">
            <div className="step2bd-title">
                { t('messages.aml.cdi.step2Bd.heading') }
            </div>
            <div>
                <Form>
                    <Row className="step2bd-field-select" gutter={[30,0]}>
                        <Col span={5}>
                            <Form.Item label={ t('messages.aml.cdi.steps.categoryLabel') }>
                                { getFieldDecorator('category', {
                                    rules: [{
                                        required: true,
                                        message: t('messages.aml.cdi.step2Bd.categoryRequired')
                                    }],
                                    initialValue: category
                                })(
                                    <Select onChange={onChangeCategory}>
                                        <Select.Option value="CLIENTE">{ t('messages.aml.cdi.steps.catCliente') }</Select.Option>
                                        <Select.Option value="COLABORADOR">{ t('messages.aml.cdi.steps.catColaborador') }</Select.Option>
                                        <Select.Option value="PROVEEDOR">{ t('messages.aml.cdi.steps.catProveedor') }</Select.Option>
                                        <Select.Option value="DIRECTOR">{ t('messages.aml.cdi.steps.catDirector') }</Select.Option>
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={5}>
                            <Form.Item label={ t('messages.aml.cdi.step2Bd.personTypeLabel') }>
                                { getFieldDecorator('typePerson', {
                                    rules: [{
                                        required: true,
                                        message: t('messages.aml.cdi.step2Bd.personTypeRequired')
                                    }],
                                    initialValue: "Person"
                                })(
                                    <Select>
                                        <Select.Option value="Person">{ t('messages.aml.cdi.step2Bd.personNatural') }</Select.Option>
                                        <Select.Option value="Entity">{ t('messages.aml.cdi.step2Bd.personJuridica') }</Select.Option>
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        { currentUser.cliente.outsourcer && currentUser.cliente.clientes && currentUser.cliente.clientes.length > 0 &&
                          <Col span={5}>
                              <Form.Item label={ t('messages.aml.cdi.step2Bd.companyLabel') }>
                                  { getFieldDecorator('company', {
                                      rules: [{
                                          required: false,
                                          message: t('messages.aml.cdi.step2Bd.companyLabel')
                                      }]
                                  })(
                                      <Select allowClear>
                                           {(currentUser.empresas !== null && currentUser.empresas.length > 0) ?
                                              currentUser.empresas.map( (c) => <Select.Option value={c.id}>{c.name}</Select.Option>)
                                           :
                                           <Select.Option value="N/A">{ t('messages.aml.cdi.step2Bd.noCompanies') }</Select.Option>
                                           }
                                      </Select>
                                  )}
                              </Form.Item>
                          </Col>
                        }
                        <Col span={5}>
                            <Form.Item label={ t('messages.aml.cdi.step2Bd.areaLabel') }>
                            { getFieldDecorator('area', {
                                rules: [{
                                    required: false,
                                    message: t('messages.aml.cdi.step2Bd.areaLabel')
                                }]
                            })(
                                <Select allowClear>
                                     {(area.length > 0) ?
                                        area.map( (c) => <Select.Option value={c}>{c}</Select.Option>)
                                     :
                                        <Select.Option value="N/A">{ t('messages.aml.cdi.step2Bd.noArea') }</Select.Option>
                                     }
                                </Select>
                            )}
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item label={ t('messages.aml.cdi.step2Bd.groupLabel') }>
                            { getFieldDecorator('segment', {
                                rules: [{
                                    required: false,
                                    message: t('messages.aml.cdi.step2Bd.segmentRequired')
                                }]
                            })(
                                <Select allowClear>
                                  { grupos.map(g =>
                                    <Select.Option value={g.grupo}>{g.grupo}</Select.Option>
                                  )}
                                </Select>
                            )}
                            </Form.Item>
                        </Col>
                        <Col span={10}>
                            <Form.Item label={ t('messages.aml.cdi.steps.declTypeLabel') }>
                            { getFieldDecorator('typeDecl', {
                                rules: [{
                                    required: true,
                                    message: t('messages.aml.cdi.step2Bd.declTypeRequired')
                                }],
                            })(
                                <Select
                                    placeholder={ t('messages.aml.cdi.steps.declTypePlaceholder') }
                                    style={{width: '100%'}} 
                                    >
                                    {formTypeValidator(currentUser, category).map(type => {
                                        return <Select.Option value={type}>{t('messages.aml.type.'+type)}</Select.Option>
                                    })}
                                </Select>
                            )}
                            </Form.Item>
                        </Col>
                        
                    </Row>
                </Form>
            </div>
            <div className="steps-buttons">
                <Button  onClick={() => prev()}>
                    { t('messages.aml.cdi.steps.prev') }
                </Button>
                <Button style={{ marginLeft: 8 }} type="primary" onClick={() => nextStepLocal()}>
                    { t('messages.aml.cdi.steps.next') }
                </Button>
            </div>
        </div>
    )
}
export default Form.create()(Step2Bd);
